import React from "react";
import { motion } from "framer-motion"; // استيراد المكتبة
import peopleImage from "../assets/hero-image.png"; // استيراد صورة الشخصين
import AboutUs from "./AboutUs";
import Services from "./Services";
import LogoSection from "./LogoSection";
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-primary via-secondary to-background overflow-hidden pt-28">
      {/* خلفية الفيديو */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src="/hero-background.mp4" type="video/mp4" />
        المتصفح لا يدعم الفيديو.
      </video>

      {/* الطبقة الشفافة بتدرج مخصص */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#292260ff] to-[#292260ee]"></div>

      {/* صورة الأشخاص مع حركة للأعلى وللأسفل */}
      <div className="relative z-10 flex items-center justify-center w-full h-full flex-col text-center">
        {/* استخدام Framer Motion لتحريك الصورة مع انحناء مخصص */}
        <motion.img
          src={peopleImage}
          alt="Persons"
          className="w-3/4 md:w-1/3 lg:w-1/4 custom-radius"  // تطبيق الانحناء المخصص
          animate={{
            y: ["0px", "-20px", "0px"], // الحركة للأعلى وللأسفل
          }}
          transition={{
            duration: 5, // مدة الحركة
            ease: "easeInOut", // تأثير الحركة
            repeat: Infinity, // التكرار اللانهائي
            repeatType: "loop", // النوع اللانهائي
          }}
        />

        {/* العنوان والنصوص */}
        <motion.h1
          className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 1 }}
        >
          مرحبًا بك في عالم الإبداع
        </motion.h1>

        <motion.p
          className="text-xl md:text-2xl text-white mb-6"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.7, duration: 1 }}
        >
          اكتشف أفضل الحلول الإبداعية والخدمات المتميزة
        </motion.p>

        {/* أزرار التفاعل */}
        <motion.div
          className="flex space-x-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 1 }}
        >
          <a
            href="#about-us"
            className="bg-indigo-500 text-white py-3 px-6 rounded-lg hover:bg-indigo-600 transition"
          >
            تعرف أكثر
          </a>
          <a
            href="#services"
            className="bg-transparent border-2 border-white text-white py-3 px-6 rounded-lg hover:bg-white hover:text-indigo-500 transition"
          >
            خدماتنا
          </a>
        </motion.div>

        {/* الأقسام الأخرى */}
        <AboutUs />
        <LogoSection />
        <Services />
      </div>
    </section>
  );
};

export default HeroSection;
